import React, { useState , useContext , useEffect} from 'react';
import { Check, X } from 'lucide-react';
import "./ChargesandCommissionCradit.css";
import { GlobalContext } from '../../Context/GlobalState';
import { BASE_URL_APISERVICES } from '../../utils/Constants';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';
import { adminAuth } from '../../config';

export default function ChargesCommissionCredit() {

    const { username1, password1 } = adminAuth;
    const [adminId, setAdminId] = useState("10");
    const [amount, setAmount] = useState("");
    const [services, setServices] = useState("");
    const [remarks, setRemarks] = useState("");
    const [agentId, setAgentId] = useState("");
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("success");
    const [modalMessage, setModalMessage] = useState("");
    const { setTransactionLoaderState , user} = useContext(GlobalContext);




    const validateForm = () => {
        const newErrors = {};

        if (!amount || amount <= 0) newErrors.amount = "Invalid amount";
        if (!services) newErrors.services = "Please select Services";
        if (!remarks.trim()) newErrors.remarks = "Remark is required";
        if (!agentId.trim()) newErrors.agentId = "Agent ID is required";


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const resetForm = () => {
        setAmount("");
        setServices("");
        setRemarks("");
        setAgentId("")
        setErrors({});
    };





    const handleSubmit = async () => {
        if (loading) return;
        if (!validateForm()) return;

        try {
            setLoading(true);

            const payload = {
                adminId: user.pkid,
                amount: amount.toString(),
                service: services,
                remarks: remarks.trim().startsWith("Txn -") ? remarks.trim() : `Txn - ${remarks.trim()}`,
                agentId: agentId.trim(),
            };

          const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append(
                "Authorization",
                "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
                );

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(payload),
                redirect: "follow",
            };

            const res = await fetch(
                `${BASE_URL_APISERVICES}${API_ENDPOINTS.CREDIT_COMM}`,
                requestOptions
            );

            const data = await res.json();

            if (data?.responseCode === "00") {
                setModalType("success");
                setModalMessage(data.responseMessage);
                setShowModal(true);
                resetForm();
            } else {
                setModalType("error");
                setModalMessage(data?.responseMessage || "Transaction Failed");
                setShowModal(true);
            }

        } catch (error) {
            const message = error?.message || "Server error occurred";

            setModalType("error");
            setModalMessage(message);
            setShowModal(true);
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div id="secure-ui" className="cc-wrapper">
            <div className="cc-text-center cc-mb-5">
                <h1 className="cc-title">Charges & Commission Credit</h1>
                <p className="cc-subtitle">Fill in the details below to process your credit request</p>
            </div>
            <div className="cc-card">
                <div className="cc-form-grid">
                    <div>
                        <label className="cc-label cc-mb-2">Total Amount</label>
                        <div className="cc-input-group">
                            <span className="cc-symbol">₹</span>
                            <input
                                type="number"
                                className="cc-input"
                                style={{ fontSize: '1.25rem' }}
                                placeholder="0.00"
                                value={amount}
                                onChange={(e) => {
                                    setAmount(e.target.value);
                                    setErrors({ ...errors, amount: "" });
                                }}
                            />
                        </div>
                        {errors.amount && <div className="cc-error-text">{errors.amount}</div>}
                    </div>


                    <div>
                        <label className="cc-label cc-mb-2">Category / Services</label>
                        <div className="cc-input-group">
                            <select
                                className="cc-input cc-select"
                                value={services}
                                onChange={(e) => {
                                    setServices(e.target.value);
                                    setErrors({ ...errors, services: "" });
                                }}
                            >
                                <option value="" disabled>Choose Services</option>
                                <option value="VENDOR PAYMENT COMMISSION">Vendor Payment Commission</option>
                                <option value="CMS SERVICE COMMISSION">CMS Service Commission</option>
                                <option value="UPI SETTLEMENT CHARGES">UPI Settlement Charges</option>
                                <option value="AEPS COMMISSION">AEPS Commission</option>
                                <option value="QR TRANSACTION ADDON">QR TRANSACTION ADDON</option>
                            </select>
                        </div>
                        {errors.services && <div className="cc-error-text">{errors.services}</div>}
                    </div>


                    <div>
                        <label className="cc-label cc-mb-2">Transaction Remarks</label>
                        <div className="cc-input-group">
                            <span className="cc-badge">Txn -</span>
                            <input
                                type="text"
                                className="cc-input"
                                placeholder="Enter Remarks"
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                            />
                        </div>
                        {errors.remarks && <div className="cc-error-text">{errors.remarks}</div>}
                    </div>
                    <div>
                        <label className="cc-label cc-mb-2">Agent Identifier</label>
                        <div className="cc-input-group">
                            <input
                                type="text"
                                className="cc-input"
                                placeholder="Enter Agent Id"
                                value={agentId}
                                onChange={(e) => setAgentId(e.target.value)}
                            />
                        </div>
                        {errors.agentId && <div className="cc-error-text">{errors.agentId}</div>}
                    </div>

                </div>


                <button className="cc-btn" onClick={handleSubmit} disabled={loading}>
                    {loading ? "Processing Request..." : "Submit Credit Request"}
                </button>
            </div>

            {showModal && (
                <div className="cc-modal-overlay">
                    <div className="cc-modal-content">
                        <div style={{
                            width: '70px', height: '70px', borderRadius: '50%',
                            backgroundColor: modalType === "success" ? '#ecfdf5' : '#fff1f2',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem'
                        }}>
                            {modalType === "success" ? (
                                <Check size={32} color="#10b981" strokeWidth={3} />
                            ) : (
                                <X size={32} color="#ef4444" strokeWidth={3} />
                            )}
                        </div>
                        <h3 style={{ margin: '0 0 0.5rem 0', fontWeight: 'bold' }}>
                            {modalType === "success" ? "All Set!" : "Request Failed"}
                        </h3>
                        <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: '2rem' }}>
                            {modalMessage}
                        </p>
                        <button
                            className="cc-btn"
                            style={{ background: modalType === "success" ? '#10b981' : '#ef4444', marginTop: 0 }}
                            onClick={() => { setShowModal(false); resetForm(); }}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            )}
        </div>


    );
}